// IssueType enum
export const IssueTypeEnum = {
    BUG: {
        value: 'BUG',
        displayName: 'Bug report',
        color: 'rgb(255, 215, 196)',
        colorFamily: 'amber',
    },
    FEATURE: {
        value: 'FEATURE',
        displayName: 'Feature request',
        color: 'rgb(230, 204, 255)',
        colorFamily: 'purple',
    }
};

// IssueStatus enum
export const IssueStatusEnum = {
    OPEN: {
        value: 'OPEN',
        displayName: 'Open',
        color: 'rgb(254, 255, 196)',
        colorFamily: 'yellow',
        isComplete: false
    },
    WONT_FIX: {
        value: 'WONT_FIX',
        displayName: "Won't Fix",
        color: 'rgb(255, 140, 140)',
        colorFamily: 'red',
        isComplete: true
    },
    DONE: {
        value: 'DONE',
        displayName: 'Done',
        color: 'rgb(196, 255, 211)',
        colorFamily: 'green',
        isComplete: true
    }
};

// BugSource enum (only applicable to bug reports)
export const BugSourceEnum = {
    DOCS_LIST_VIEW: {
        value: 'DOCS_LIST_VIEW',
        displayName: 'Documents List View'
    },
    DOCS_DETAIL_VIEW: {
        value: 'DOCS_DETAIL_VIEW',
        displayName: 'Document Detail View'
    },
    OUTCOME_TASKS_VIEW: {
        value: 'OUTCOME_TASKS_VIEW',
        displayName: 'Outcome Tasks View'
    },
    ADMIN_VIEW: {
        value: 'ADMIN_VIEW',
        displayName: 'Admin View'
    },
    INSIGHTS_VIEW: {
        value: 'INSIGHTS_VIEW',
        displayName: 'Insights View'
    },
    CLINIC_SELECT_VIEW: {
        value: 'CLINIC_SELECT_VIEW',
        displayName: 'Clinic Selector View'
    },
    CONFIG_VIEW: {
        value: 'CONFIG_VIEW',
        displayName: 'Config View'
    },
    USER_VIEW: {
        value: 'USER_VIEW',
        displayName: 'User View'
    }
};

// Helper functions
export const getIssueTypeByValue = (value) => {
    return Object.values(IssueTypeEnum).find(type => type.value === value);
};

export const getIssueStatusByValue = (value) => {
    return Object.values(IssueStatusEnum).find(status => status.value === value);
};

export const getBugSourceByValue = (value) => {
    return Object.values(BugSourceEnum).find(source => source.value === value);
};

// Generate issue code helper (matches the Java generateIssueCode method)
export const generateIssueCode = (issueNumber) => {
    return `MDP-${issueNumber.toString().padStart(3, '0')}`;
};
